import React, {Component} from "react";
import classNames from 'classnames';

// Stylesheet file.
import '../../../assets/sass/global/cards/card-bsae.scss';

/**
 * The abstract component of the cards.
 */
class CardBase extends Component {
    /**
     * Renders the base card component.
     * @returns {React.ReactNode} The card component.
     */
    render = () => {
        const cardClasses = classNames('card-base', this.cardClasses());
        const cardHeaderClasses = classNames('card-header', this.cardHeaderClasses());
        const cardBodyClasses = classNames('card-body', this.cardBodyClasses());
        const cardFooterClasses = classNames('card-footer', this.cardFooterClasses());

        return (
            <div className={cardClasses}>
                {this.renderHeader() !== undefined && <div className={cardHeaderClasses}> {this.renderHeader()} </div>}
                {this.renderBody() !== undefined && <div className={cardBodyClasses}> {this.renderBody()} </div>}
                {this.renderFooter() !== undefined && <div className={cardFooterClasses}> {this.renderFooter()} </div>}
            </div>
        );
    };

    /**
     * Renders the header of the card component.
     * @returns {React.ReactNode} The card header component.
     */
    renderHeader = () => undefined;

    /**
     * Renders the body of the card component.
     * @returns {React.ReactNode} The card body component.
     */
    renderBody = () => undefined;

    /**
     * Renders the footer of the card component.
     * @returns {React.ReactNode} The card footer component.
     */
    renderFooter = () => undefined;

    /**
     * Returns the classes of the card component.
     * @returns {string} The card classes.
     */
    cardClasses = () => '';

    /**
     * Returns the classes of the card header component.
     * @returns {string} The card header classes.
     */
    cardHeaderClasses = () => '';

    /**
     * Returns the classes of the card body component.
     * @returns {string} The card body classes.
     */
    cardBodyClasses = () => '';

    /**
     * Returns the classes of the card footer component.
     * @returns {string} The card footer classes.
     */
    cardFooterClasses = () => '';
}

export default CardBase;
